import styled from 'styled-components';
import { Palette } from 'config';

export const Error = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
  background-color: ${Palette.PrimaryGray._100};
  svg {
    margin-left: 50%;
    margin-top: 35px;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }
  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${Palette.PrimaryGray._900};
  }
  span + span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${Palette.PrimaryGray._500};
    margin-top: 4px;
  }
`;
